var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "execution" },
    [
      _c("basic-container", [
        _c(
          "div",
          { staticClass: "header" },
          [
            _c("p", { staticClass: "header__title" }, [
              _vm._v(_vm._s(_vm.name)),
            ]),
            _c(
              "el-button",
              {
                staticClass: "header__btn",
                attrs: { type: "primary" },
                on: { click: _vm.breaks },
              },
              [_vm._v("关闭返回列表\n      ")]
            ),
          ],
          1
        ),
      ]),
      _c("el-scrollbar", { staticClass: "main" }, [
        _c("iframe", { staticClass: "iframe", attrs: { src: _vm.src } }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }